import angular from 'angular';
import booksMenu from '../../menu/Menu';

export default angular
  .module('accountTotals', [booksMenu])
  .controller('accountTotalsController', accountTotalsController)
  .name;

  
/* @ngInject */ function accountTotalsController($scope, BooksSvc, $q, BusyScreen, Session) {
  /*---------------------*/
  /* Sets default values */
  /*---------------------*/
  $scope.req = { reportFormat: 'PDF', source: 1 };
  $scope.reportPage = Session.getSessionURL('/GLAcctTotalsReport.aspx');

  /*-----------------------------------------------*/
  /* Static array for the receipt source dropdown. */
  /*-----------------------------------------------*/
  $scope.recSource = [
    { label: 'All', source: 1 },
    { label: 'Point of Sale', source: 2 },
    { label: 'Webstore', source: 3 }
  ];

  /*-----------------*/
  /* Date validation */
  /*-----------------*/
  $scope.valOption = {};
  $scope.validateInput = function () {
    return $scope.valOption.validate();
  };

  /*-------------------*/
  /* Load initial data */
  /*-------------------*/
  BooksSvc.getOrganization().then(function (resp) {
    $scope.org = resp.data;

    BooksSvc.getPermittedAccounts().then(function (resp) {
      BusyScreen.setBusy(false);
    });
  });
}
